import { Box, Container, Stack, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function BannersSct({ banners = [] }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");
  // const banners = [
  //   { alt: "", image: "/Media/SampleImages/banners.png" },
  //   { alt: "", image: "/Media/SampleImages/banners.png" },
  // ];
  const bannerItems = banners?.map((banner, index) => {
    if (banner?.position == "second") {
      return (
        <Box
          component={"a"}
          href={banner?.back_link}
          target="_blank"
          key={index}
          sx={{
            width: { xs: "100%", lg: "49%" },
            height: {
              xs: "170px",
              sm: "200px",
              md: "300px",
              lg: "250px",
              xl: "360px",
            },
            borderRadius: "1.5rem",
            overflow: "hidden",
            transition: "all .3s",
            boxShadow: `0 2px 8px 0px transparent`,
            bgcolor: "transparent",
            backdropFilter: "blur(16px)",
            cursor: "pointer",
            ":hover": {
              boxShadow: `0 2px 8px 0px ${theme.palette.primary.main}`,
            },
          }}
        >
          <img
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            src={`${import.meta.env.VITE_URL}${
              isMobile
                ? banner?.image_mobile?.file_name
                : banner?.image_desktop?.file_name
            }`}
            alt={
              isMobile ? banner?.image_mobile?.alt : banner?.image_desktop?.alt
            }
            title={
              isMobile
                ? banner?.image_mobile?.title
                : banner?.image_desktop?.title
            }
          />
        </Box>
      );
    }
  });
  return (
    <Container maxWidth={"xxl"} sx={{ position: "relative" }}>
      <Stack
        direction={"row"}
        sx={{
          // gap: "1rem",
          rowGap: "1rem",
          flexWrap: "wrap",
          justifyContent: "space-between",
          //   px: "2rem",
        }}
      >
        {bannerItems}
      </Stack>
      {/* Circle Images left Center */}
      <Box
        sx={{
          position: "absolute",
          bottom: "100%",
          left: "50%",
          transform: "translate(-40% , 70%)",
          zIndex: "-10",
          width: "350px",
          height: "350px",
          opacity: ".7",
          display: bannerItems?.length <= 0 ? "block" : "none",
        }}
      >
        <img
          style={{ width: "100%", height: "100%" }}
          src="/Media/Circles/circle.svg"
          alt="circle images"
        />
      </Box>
    </Container>
  );
}
